import Vue from "vue";
import Vuex from "vuex";
import moment from 'moment'
Vue.use(Vuex);

export default {
  state: {
      nursing_staff:[
        {
            name: 'João Fernandes',
            presence:"20",
            missing:"5",
            occupation:"Nurse",
            base:"Zona sul",
            email:"joao@gmail.com",
            phone:"92991900565",
            frequency:[
                {date:"2020-07-01",present:false},{date:"2020-07-02",present:false},{date:"2020-07-03",present:true},{date:"2020-07-04",present:false},{date:"2020-07-05",present:true},{date:"2020-07-06",present:true},{date:"2020-07-07",present:false},{date:"2020-07-08",present:false},{date:"2020-07-09",present:true},{date:"2020-07-10",present:true},{date:"2020-07-11",present:false},
            ]
        },
        {
            name: 'Augusto Soares',
            presence:"18",
            missing:"2",
            occupation:"Médico Regulador",
            base:"Zona leste",
            email:"augusto@gmail.com",
            phone:"92991900565",
            frequency:[
                {date:"2020-07-01",present:false},{date:"2020-07-02",present:false},{date:"2020-07-03",present:false},{date:"2020-07-04",present:false},{date:"2020-07-05",present:true},{date:"2020-07-06",present:true},{date:"2020-07-07",present:false},{date:"2020-07-08",present:false},{date:"2020-07-09",present:true},{date:"2020-07-10",present:true},{date:"2020-07-11",present:false},
            ]
        },
        {
            name: 'Stennes da Silva',
            presence:"20",
            missing:"5",
            occupation:"Nurse",
            base:"Zona centro",
            email:"stennes@gmail.com",
            phone:"92991900565",
            frequency:[
                {date:"2020-07-01",present:true},{date:"2020-07-02",present:true},{date:"2020-07-03",present:true},{date:"2020-07-04",present:false},{date:"2020-07-05",present:true},{date:"2020-07-06",present:true},{date:"2020-07-07",present:false},{date:"2020-07-08",present:false},{date:"2020-07-09",present:true},{date:"2020-07-10",present:true},{date:"2020-07-11",present:false},
            ]
        },
        {
            name: 'Mariene Reis',
            presence:"15",
            missing:"10",
            occupation:"Nurse",
            base:"Zona oest",
            email:"mariene@gmail.com",
            phone:"92991900565",
            frequency:[
                {date:"2020-07-01",present:true},{date:"2020-07-02",present:true},{date:"2020-07-03",present:true},{date:"2020-07-04",present:false},{date:"2020-07-05",present:true},{date:"2020-07-06",present:true},{date:"2020-07-07",present:false},{date:"2020-07-08",present:false},{date:"2020-07-09",present:true},{date:"2020-07-10",present:true},{date:"2020-07-11",present:false},
            ]
        },
        {
            name: 'Carina Guedes',
            presence:"20",
            missing:"5",
            occupation:"Tarm",
            base:"Bola da Suframa",
            email:"carina@gmail.com",
            phone:"92991900565",
            frequency:[
                {date:"2020-07-01",present:false},{date:"2020-07-02",present:false},{date:"2020-07-03",present:false},{date:"2020-07-04",present:false},{date:"2020-07-05",present:false},{date:"2020-07-06",present:false},{date:"2020-07-07",present:false},{date:"2020-07-08",present:false},{date:"2020-07-09",present:true},{date:"2020-07-10",present:true},{date:"2020-07-11",present:false},
            ]
        },
        {
            name: 'Fernando Nobel',
            presence:"22",
            missing:"6",
            occupation:"Tarm",
            base:"Zona norte",
            email:"fernando@gmail.com",
            phone:"92991900565",
            frequency:[
                {date:"2020-07-01",present:true},{date:"2020-07-02",present:false},{date:"2020-07-03",present:true},{date:"2020-07-04",present:false},{date:"2020-07-05",present:true},{date:"2020-07-06",present:true},{date:"2020-07-07",present:false},{date:"2020-07-08",present:false},{date:"2020-07-09",present:true},{date:"2020-07-10",present:true},{date:"2020-07-11",present:false},
            ]

        },
      ],
      selectedNurse:undefined
  },
  mutations: {
    setNursingStaff(state, payload) {
        state.nursing_staff = payload
    },
    addNewFrequency(state,payload){
        state.nursing_staff[payload.id].frequency.push({date:payload.date,present:payload.present})
    },
    setSelectedNurse(state, payload) {
        state.selectedNurse = payload
    },
  },
  actions: {
    setNursingStaff({commit},payload){
        commit('setNursingStaff',payload)
    },
    addNewFrequency({commit},payload){
        let copyPayload = Object.assign({},payload)
        commit('addNewFrequency',copyPayload)
    },
    setSelectedNurse({commit},payload){
        commit('setSelectedNurse',payload)
    },
  },
  getters: {
    selectedNurse(state) {
      return state.selectedNurse;
    },
    nursingStaff(state){
        return state.nursing_staff
    }
  }
};
